import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import { UpdateFormTemplateKeyDto } from './types';

/**
 * Update an existing form template key
 */
export async function updateFormTemplateKey(
  keyId: string,
  data: UpdateFormTemplateKeyDto
): Promise<{ success: boolean }> {
  try {
    const res = await fetcher(`${BASE_URL}/${keyId}`, {
      method: 'POST',
      body: data,
    });

    if (!res.ok) {
      console.error('Failed to update form template key:', await res.text());
      return { success: false };
    }

    return { success: true };
  } catch (err) {
    console.error('Error updating form template key:', err);
    return { success: false };
  }
}

